const state = {
    action: ''
};

const getters = {
    action: (state) => state.action
};

const mutations = {
    setAction(state, action) {
        state.action = action;
    }
};

const actions = {
    initiateAction(context, action) {
        context.commit('setAction', action);
    },
};



export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
